import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_TRANSLATIONS]: isLoading,
  [actionTypes.FETCH_TRANSLATIONS_SUCCESS]: isEnding,
  [actionTypes.FETCH_TRANSLATIONS_FAILURE]: isEnding,
});
